import { useNavigate } from "react-router-dom";
import { API } from "../../config/api";
import { DELETE, GET, POST } from "../../utils/apicalls";
import { Button, Card, DatePicker, Form, Input, Modal, notification, Select, Space, Table } from "antd";
import React, { useEffect, useState } from "react";
import LoadingAnimation from "../../componets/loader/loader";
import { Col, Row } from "react-bootstrap";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Initialize dayjs plugins for timezone handling
dayjs.extend(utc);
dayjs.extend(timezone);

function OfferManagement() {
    const [isLoading, setIsLoading] = useState(false);
    const [ProductData, setProductData] = useState<any>([]);
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [meta, setMeta] = useState<any>({});
    const [data, setData] = useState<any>([]);

    const fetchProductsGet = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.PRODUCT_GET_LISTING, {});
            setProductData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchProductsGet();
        fetchofferproduct()
    }, []);

    const fetchofferproduct = async () => {
        try {
            setIsLoading(true);
            const url = API.LIST_OFFER_PRODUCT;
            const response: any = await GET(url, {});

            // Convert UTC times to local timezone for display
            const formattedData = response?.data?.map((item: any) => ({
                ...item,
                Offer_start_time: item.Offer_start_time ?
                    dayjs.utc(item.Offer_start_time).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss') : '',
                Offer_End_time: item.Offer_End_time ?
                    dayjs.utc(item.Offer_End_time).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss') : ''
            }));

            setData(formattedData);
            setMeta(response?.meta);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const submitHandler = async (values: any) => {
        try {
            const obj = {
                Offer_start_time: startTime,
                Offer_End_time: endTime,
                Offer_price: Number(values.Offer_price),
                Product_id: values.Product_id,
            };

            setIsLoading(true);
            const postRequest: any = await POST(API.CREATE_OFFER_PRODUCT, obj);
            if (postRequest.status) {
                notification.success({ message: "Offer created successfully!" });
                form.resetFields();
                setIsModalOpen(false);
                fetchofferproduct();
            } else {
                notification.error({ message: postRequest.message || "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (id: any) => {
        try {
            setIsLoading(true);
            const delete_customer_url = `${API.DELETE_OFFER_PRODUCT}${id}`;
            const data: any = await DELETE(delete_customer_url);

            if (data.status) {
                notification.success({ message: " deleted successfully!" });
                fetchofferproduct();
            } else {
                notification.error({
                    message: "Something went wrong! Please try again later.",
                });
            }
        } catch (error) {
            console.log(error);
            notification.error({
                message: "Something went wrong! Please try again later.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const confirmDelete = (id: any) => {
        const confirm = window.confirm(
            "Are you sure you want to delete this review?"
        );
        if (confirm) {
            handleDelete(id);
        }
    };

    const columns = [
        {
            title: "Index",
            dataIndex: "index",
            render: (_: any, __: any, index: number) => index + 1,
        },
        { title: "Offer Start Time", dataIndex: "Offer_start_time" },
        { title: "Offer End Time", dataIndex: "Offer_End_time" },
        { title: "Offer Price", dataIndex: "Offer_price" },
        {
            title: "Product",
            dataIndex: "Product",
            render: (_: any, record: any) => (
                <span>{record?.Productid?.productTitle}</span>
            ),
        },
        {
            title: "Actions",
            key: "actions",
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Button type="link" onClick={() => confirmDelete(record.id)}>
                        Delete
                    </Button>
                    {/* <Button
                        type="link"
                        onClick={() =>
                            navigate(`/admin/offerpage/updateoffer/${record.id}`)
                        }
                    >
                        Edit
                    </Button> */}
                </Space>
            ),
        },
    ];

    return (
        <div>
            <div className="banner-container">
                {isLoading ? (
                    <LoadingAnimation />
                ) : (
                    <div className="banner-content">
                        <h1 className="banner-title">Offer Management</h1>
                        <button className="banner-button" onClick={() => setIsModalOpen(true)}>
                            Create Offer
                        </button>
                    </div>
                )}
                <button className="banner-button" onClick={() => navigate(`/Admin/viewActiveOffer`)}>
                    View Active Offers
                </button>
            </div>
            <Card>
                <Table
                    columns={columns}
                    dataSource={data}
                    loading={isLoading}
                    pagination={{
                        current: page,
                        pageSize: pageSize,
                        total: meta?.total,
                        showSizeChanger: true,
                        onChange: (newPage, newPageSize) => {
                            setPage(newPage);
                            setPageSize(newPageSize);
                        },
                    }}
                    rowKey={(record: any) => record.id}
                    scroll={{ x: "max-content" }}
                />
            </Card>
            {/* Offer Creation Modal */}
            <Modal
                title="Add Offer"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                width="50%"
            >
                <Form form={form} onFinish={submitHandler} layout="vertical">
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="Offer_start_time" label="Offer Start Time" rules={[{ required: true }]}>
                                <DatePicker
                                    showTime={{ format: "HH:mm:ss" }}
                                    format="YYYY-MM-DD HH:mm:ss"
                                    onChange={(value) => setStartTime(value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "")}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="Offer_End_time" label="Offer End Time" rules={[{ required: true }]}>
                                <DatePicker
                                    showTime={{ format: "HH:mm:ss" }}
                                    format="YYYY-MM-DD HH:mm:ss"
                                    onChange={(value) => setEndTime(value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "")}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="Offer_price" label="Offer Price" rules={[{ required: true }]}>
                                <Input type="number" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="Product_id" label="Product" rules={[{ required: true }]}>
                                <Select placeholder="Select a Product">
                                    {ProductData?.map((product: any) => (
                                        <Select.Option key={product.id} value={product.id}>
                                            {product.productTitle}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Button type="primary" htmlType="submit" block>
                        Submit
                    </Button>
                </Form>
            </Modal>
        </div>
    );
}

export default OfferManagement;